//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

import VirtualTour from '../VirtualTour.vue' 

export default {
  props: {
    block: {
      type: Object,
      default: null
    }
  },
  components: {
    VirtualTour
  },
  computed: {
    activeVenues() {
      return this.block.slides[this.ui.currentSlide].venues
    }
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      ui: {
        currentSlide: 0,
        currentVenue: 0
      },
      sliderOptions: {
          wrapAround: true,
          adaptiveHeight: true,
          groupCells: 3
          // any options from Flickity can be used
      },
      glideOptions: {
        perView: 1,
        type: 'carousel',
        
      }
      
    }
  },
  mounted() {
    console.log('LODGINT ITEMS', this.block.venues)

  },
  methods: {

    slideChanged: function ($event) {

      this.ui.currentSlide = $event.currentSlide.index
      

      
    },
   

    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/KitBlocks/KitLodging.vue